module.exports = __webpack_public_path__ + "img/stickers_0011_couple.d67d2727.png";